// dependencies
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import SearchAgainBtn from './../Utils/SearchAgainBtn';
import NotFound from './../Utils/NotFound';
import SomethingWrong from './../Utils/SomethingWrong';
import ScaleLoader from 'react-spinners/ScaleLoader';
import confetti from 'canvas-confetti';
import axios from 'axios';
import './Result.css';

// generate random boolean
const rand = Math.random() >= 0.5;

// confetti configuration
const showConfetti = function () {
   if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
         navigator.userAgent
      )
   ) {
      // true for mobile device
      const count = 150;
      const defaults = {
         origin: { y: 0.7 },
      };

      function fire(particleRatio, opts) {
         confetti(
            Object.assign({}, defaults, opts, {
               particleCount: Math.floor(count * particleRatio),
            })
         );
      }

      fire(0.25, {
         spread: 26,
         startVelocity: 55,
      });
      fire(0.2, {
         spread: 60,
      });
      fire(0.35, {
         spread: 100,
         decay: 0.91,
         scalar: 0.8,
      });
      fire(0.1, {
         spread: 120,
         startVelocity: 25,
         decay: 0.92,
         scalar: 1.2,
      });
      fire(0.1, {
         spread: 120,
         startVelocity: 45,
      });
   } else {
      // false for not mobile device
      if (rand) {
         const end = Date.now() + 2 * 1000;

         // go Buckeyes!
         const colors = ['#bb0000', '#ffffff'];

         (function frame() {
            confetti({
               particleCount: 2,
               angle: 60,
               spread: 55,
               origin: { x: 0 },
               colors: colors,
            });
            confetti({
               particleCount: 2,
               angle: 120,
               spread: 55,
               origin: { x: 1 },
               colors: colors,
            });

            if (Date.now() < end) {
               requestAnimationFrame(frame);
            }
         })();
      } else {
         const duration = 3 * 1000;
         const animationEnd = Date.now() + duration;
         const defaults = {
            startVelocity: 30,
            spread: 360,
            ticks: 60,
            zIndex: 0,
         };

         function randomInRange(min, max) {
            return Math.random() * (max - min) + min;
         }

         const interval = setInterval(function () {
            const timeLeft = animationEnd - Date.now();

            if (timeLeft <= 0) {
               return clearInterval(interval);
            }

            const particleCount = 50 * (timeLeft / duration);
            // since particles fall down, start a bit higher than random
            confetti(
               Object.assign({}, defaults, {
                  particleCount,
                  origin: {
                     x: randomInRange(0.1, 0.3),
                     y: Math.random() - 0.2,
                  },
               })
            );
            confetti(
               Object.assign({}, defaults, {
                  particleCount,
                  origin: {
                     x: randomInRange(0.7, 0.9),
                     y: Math.random() - 0.2,
                  },
               })
            );
         }, 250);
      }
   }
};

const Result = () => {
   const [loading, setLoading] = useState(true);
   const [error, setError] = useState(false);
   const { state: formData } = useLocation();
   const [result, setResult] = useState({});

   useEffect(() => {
      const { roll, semester } = formData;

      try {
         // http://localhost:4000/api/v1/results
         axios
            .post('https://api-bteb.vercel.app/api/v1/results', {
               roll,
               semester,
            })
            .then((res) => {
               setError('');
               setLoading(false);
               setResult(res.data);
            })
            .catch(() => {
               setResult({});
               setLoading(false);
               setError(true);
            });
      } catch (err) {
         setLoading(false);
         setResult({});
         setError('There was a server problem!');
      }
   }, [formData]);

   // loader css
   const loaderStyle = {
      display: 'flex',
      textAlign: 'center',
      justifyContent: 'center',
      alignItems: 'center',
      flexWrap: 'wrap',
      height: '100vh',
      background: '#15202c',
   };

   return (
      <div className="common-blue content result-wrapper">
         {loading ? (
            <ScaleLoader css={loaderStyle} color="#A3DBDB" loading={loading} />
         ) : (
            <>
               <div className="greetings">
                  {result?.data?.status === 'PASSED' && (
                     <>
                        <img src="img/happy.svg" alt="PASSED" />
                        <h1 className="passed">Congratulations, You Passed!</h1>
                     </>
                  )}
                  {result?.data?.status === 'FAILED' && (
                     <>
                        <img src="img/sad.svg" alt="FAILED" />
                        <h1 className="failed">Sorry, You Failed!</h1>
                     </>
                  )}
                  {result?.status === 'error' && <NotFound />}
                  {error && <SomethingWrong />}
               </div>

               {result?.status !== 'error' && !error ? (
                  <div className="result-data">
                     <h2> Your Roll : {result?.data?.roll} </h2>
                     <h2>
                        {result?.data?.status === 'PASSED'
                           ? 'You Got : '
                           : 'Your Result : '}
                        {/* {result?.data?.result.replace(/[{/}]/gm, '')} */}
                        {result?.data?.result}
                     </h2>
                     <h2> Semester : {result?.data?.semester} </h2>
                     {result?.data?.session && (
                        <h2> Session : {result?.data?.session} </h2>
                     )}
                     {result?.data?.status === 'PASSED' ? showConfetti() : null}
                  </div>
               ) : null}
               <SearchAgainBtn />
            </>
         )}
      </div>
   );
};

export default Result;
